import React from 'react';
import './App.css';
import Nav from './components/site/Nav';
import Hero from './components/site/Hero';
import LogoTicker from './components/site/LogoTicker';
import About from './components/site/About';
import TrainingPrograms from './components/site/TrainingPrograms';
import ImpactNumbers from './components/site/ImpactNumbers';
import Testimonials from './components/site/Testimonials';
import HowItWorks from './components/site/HowItWorks';
import TopicsCloud from './components/site/TopicsCloud';
import Blog from './components/site/Blog';
import Contact from './components/site/Contact';
import Footer from './components/site/Footer';
import FloatingWhatsApp from './components/site/FloatingWhatsApp';
import CustomCursor from './components/site/CustomCursor';

function App() {
  return (
    <div className="App grain min-h-screen bg-[#0a0a0f] text-white">
      <CustomCursor />
      <Nav />
      <main>
        <Hero />
        <LogoTicker />
        <About />
        <TrainingPrograms />
        <ImpactNumbers />
        <Testimonials />
        <HowItWorks />
        <TopicsCloud />
        <Blog />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
